const currentAssessmentService = {
  saveToLocalStorage(assessment: unknown): void {
    localStorage.setItem('currentAssessment', JSON.stringify(assessment));
  },

  obtainFromLocalStorage(): unknown {
    const JSONAssessment = localStorage.getItem('currentAssessment');
    const assessmentObj = JSON.parse(JSONAssessment);
    return assessmentObj;
  },

  clearLS(): void {
    localStorage.removeItem('currentAssessment');
  },
};

export default currentAssessmentService;
